import React from 'react';
import { Alert, Button } from '@mui/material';

export default class PageBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? <Alert severity="error" action={<Button onClick={() => window.location.reload()}>Reload</Button>}>This page could not load. Reload to get the latest application files.</Alert> : this.props.children;
  }
}
